<template>
    <div>
        Aba Historico de Pedidos
    </div>
</template>

<script>
export default {
    props: {
        data: {
            type: Object,
            default: () => {}
        },
    },
    data() {
        return {
            msgs: [],
        }
    },

    created () {
    },
    methods: {
    },
}
</script>

<style lang="scss">
</style>

